import { BlendRecipe } from '../api/client';

export default function BlendRecipeDisplay({
  recipe,
  prominent = false,
}: {
  recipe?: BlendRecipe | null;
  prominent?: boolean;
}) {
  if (!recipe) {
    return (
      <div className={`rounded-xl border border-orange-300 bg-orange-50 text-orange-800 ${prominent ? 'p-4 text-2xl font-bold' : 'mt-2 p-2 text-xs font-semibold'}`}>
        ⚠ לא הוגדר מתכון טעינה לתערובת
      </div>
    );
  }

  return (
    <section
      dir="rtl"
      className={`rounded-xl border-2 border-amber-300 bg-amber-50 ${prominent ? 'min-w-0 p-3' : 'mt-2 p-2'}`}
      aria-label="מתכון טעינת פולים"
    >
      <div className={`font-bold text-amber-900 ${prominent ? 'mb-2 text-3xl' : 'mb-1 text-sm'}`}>
        ⚖ מתכון טעינה — {recipe.total_kg} ק״ג
      </div>
      {prominent ? (
        <table className="w-full border-separate border-spacing-y-1 text-right">
          <thead className="text-sm text-amber-900 sm:text-base">
            <tr>
              <th scope="col" className="px-2 pb-1">רכיב</th>
              <th scope="col" className="px-2 pb-1 sm:whitespace-nowrap">כמות (ק״ג)</th>
              <th scope="col" className="px-2 pb-1 sm:whitespace-nowrap">סה״כ (ק״ג)</th>
            </tr>
          </thead>
          <tbody className="text-2xl font-bold leading-tight text-black sm:text-[32px] sm:leading-[1.125]">
            {recipe.ingredients.map((ingredient, index) => (
              <tr key={`${ingredient.name}-${index}`}>
                <td className="rounded-r-lg border-y border-r border-amber-200 bg-white px-2 py-1 [overflow-wrap:anywhere]">
                  <bdi>{index + 1}.</bdi> {ingredient.name}
                </td>
                <td className="w-px whitespace-nowrap border-y border-amber-200 bg-white px-2 py-1 tabular-nums">
                  <bdi>{ingredient.amount_kg}</bdi>
                </td>
                <td className="w-px whitespace-nowrap rounded-l-lg border-y border-l border-amber-200 bg-white px-2 py-1 text-3xl font-extrabold tabular-nums text-gray-900 sm:text-[40px]">
                  <bdi>{ingredient.cumulative_kg}</bdi>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <ol className="space-y-1">
          {recipe.ingredients.map((ingredient, index) => (
            <li
              key={`${ingredient.name}-${index}`}
              className="flex items-center justify-between gap-3 rounded-lg border border-amber-200 bg-white px-2 py-1 text-xs font-bold"
            >
              <span><bdi>{index + 1}.</bdi> {ingredient.name}</span>
              <span className="whitespace-nowrap">
                <bdi>{ingredient.amount_kg}</bdi> ק״ג
                <span className="mr-1 text-sm text-gray-500">
                  (סה״כ <bdi>{ingredient.cumulative_kg}</bdi>)
                </span>
              </span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
